import React from "react";

interface Props {
  title: string | React.ReactNode
  subTitle?: string | React.ReactNode
}

const PanelSegmentTitle = (props: Props) => {
  const { title, subTitle } = props;

  const isTitleText = typeof title === "string";
  const isTitleReactNode = !isTitleText && title != null;

  const isSubtitleText = typeof subTitle === "string";
  const isSubtitleReactNode = !isSubtitleText && subTitle != null;

  return <div className="grow1">
    {(isTitleText && title) && <div className="header-title">
      {title}
    </div>}

    {isTitleReactNode && title}

    {(isSubtitleText && subTitle) && <div className="header-subTitle">
      {subTitle}
    </div>}

    {isSubtitleReactNode && subTitle}
  </div>;
};

export default PanelSegmentTitle;